import { useEffect } from 'react';
import { MapContainer, TileLayer, Marker, Popup, Circle, useMap } from 'react-leaflet';
import 'leaflet/dist/leaflet.css';
import L from 'leaflet';

// Fix for default marker icons in Leaflet
delete L.Icon.Default.prototype._getIconUrl;
L.Icon.Default.mergeOptions({
    iconRetinaUrl: 'https://cdnjs.cloudflare.com/ajax/libs/leaflet/1.7.1/images/marker-icon-2x.png',
    iconUrl: 'https://cdnjs.cloudflare.com/ajax/libs/leaflet/1.7.1/images/marker-icon.png',
    shadowUrl: 'https://cdnjs.cloudflare.com/ajax/libs/leaflet/1.7.1/images/marker-shadow.png',
});

const userIcon = new L.Icon({
    iconUrl: 'https://raw.githubusercontent.com/pointhi/leaflet-color-markers/master/img/marker-icon-2x-blue.png',
    shadowUrl: 'https://cdnjs.cloudflare.com/ajax/libs/leaflet/1.7.1/images/marker-shadow.png',
    iconSize: [25, 41],
    iconAnchor: [12, 41],
    popupAnchor: [1, -34],
    shadowSize: [41, 41],
});

const warehouseIcon = new L.Icon({
    iconUrl: 'https://raw.githubusercontent.com/pointhi/leaflet-color-markers/master/img/marker-icon-2x-red.png',
    shadowUrl: 'https://cdnjs.cloudflare.com/ajax/libs/leaflet/1.7.1/images/marker-shadow.png',
    iconSize: [25, 41],
    iconAnchor: [12, 41],
    popupAnchor: [1, -34],
    shadowSize: [41, 41],
});

function MapResizer({ center, radiusKm }) {
    const map = useMap();
    useEffect(() => {
        if (center?.[0] && center?.[1]) {
            // Use a padding to make sure the circle is well visible
            map.flyTo(center, 11, { duration: 1.5 });
        }
    }, [center, map]);
    return null;
}

export default function DeliveryRangeMap({ userLocation, warehouseLocation, radiusKm = 18 }) {
    const defaultCenter = [-1.286389, 36.817223]; // Nairobi
    const center = warehouseLocation ? [warehouseLocation.lat, warehouseLocation.lng] : defaultCenter;

    return (
        <div className="mt-4" style={{ height: '350px', width: '100%', borderRadius: '12px', overflow: 'hidden', border: '1px solid #E0E0E0' }}>
            <MapContainer center={center} zoom={11} style={{ height: '100%', width: '100%' }}>
                <MapResizer center={center} radiusKm={radiusKm} />
                <TileLayer
                    attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a>'
                    url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
                />

                {warehouseLocation && (
                    <>
                        <Marker position={[warehouseLocation.lat, warehouseLocation.lng]} icon={warehouseIcon}>
                            <Popup>
                                <strong>Central Warehouse</strong>
                                <br />Fulfillment Center
                            </Popup>
                        </Marker>
                        <Circle
                            center={[warehouseLocation.lat, warehouseLocation.lng]}
                            radius={radiusKm * 1000} // radius in meters
                            pathOptions={{ 
                                color: '#F05023', 
                                fillColor: '#F05023', 
                                fillOpacity: 0.1,
                                weight: 2
                            }}
                        />
                    </>
                )}

                {userLocation && (
                    <Marker position={[userLocation.lat, userLocation.lng]} icon={userIcon}>
                        <Popup>
                            <strong>Your Location</strong>
                            <br />Delivery Address
                        </Popup>
                    </Marker>
                )}
            </MapContainer>
        </div>
    );
}
